/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { models_GroupType } from './models_GroupType';
export type groups_CreateGroupRequest = {
    age_max?: number;
    age_min?: number;
    avatarUrl?: string;
    childcare_id?: string;
    color?: string;
    description?: string;
    icon?: string;
    /**
     * LeadEmployeeID is HAND-SET (issue #1217). "" is normalised to nil: a
     * group with no lead is normal. x-nullable so the generated clients accept
     * an explicit JSON null instead of rejecting it.
     */
    lead_employee_id?: string | null;
    max_headcount: number;
    max_weighted_headcount: number;
    name: string;
    sort_order?: number;
    status?: groups_CreateGroupRequest.status;
    subsidy_type?: models_GroupType;
    type?: models_GroupType;
};
export namespace groups_CreateGroupRequest {
    export enum status {
        ACTIVE = 'ACTIVE',
        INACTIVE = 'INACTIVE',
    }
}

